// globalMethods.js
export default {
    install(app) {
        app.config.globalProperties.$loadAtencionesYsignosVitales = function () {
            return this.$https.post('/consulta/getLoadTicketAtencion', {}, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": this.tokenAuth,
                }
            }).then(response => {
                console.log(response.data.datos);

                if (response.data.code === 200) {
                    return response.data.datos; // Devuelve los datos
                }
            }).catch(error => {
                if (error?.response?.status === 400) {
                    this.$swal.fire({
                        title: "Ocurrió algo!",
                        html: `<p style="color: #eb1265; font-weight: bold; font-size: 13px;">${error.response.data.message}</p>`,
                        icon: "warning",
                        width: "400px",
                        customClass: {
                            confirmButton: "btn btn-primary",
                            cancelButton: "btn btn-outline-secondary ml-1",
                        },
                        buttonsStyling: false,
                    });
                }

                if (error?.response?.status === 401) {
                    this.showSessionExpiredAlert();
                }
                throw error; // Relanza el error para manejarlo en el componente
            });
        };
    }
};